import { useState } from "react";
import { StageDetails } from "../../types/tournament";
import { DescriptionItem, DescriptionList, Dialog } from "../../ui";
import { formatPlannedRounds, isAmericanoFormat, playersPerSideFor } from "../../utils/methods";
import "./styles.scss";

type StageDetailDialogProps = {
  stage: StageDetails;
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const StageDetailDialog = (props: StageDetailDialogProps) => {
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const handleCancel = () => {
    setIsEdit(false);
  };

  // The page renders this before the stage has loaded, so every read is optional.
  const stage = props.stage;
  const items: DescriptionItem[] = [{ label: "Format", value: stage?.formatName }];

  if (stage?.formatName === "Knockout") {
    items.push(
      { label: "Mode", value: stage?.knockoutRules?.mode === "single" ? "Single Elimination" : "Double Elimination" },
      { label: "Third Place Match", value: stage?.knockoutRules?.hasThirdPlaceMatch ? "Yes" : "No" }
    );
  }

  if (stage?.formatName === "League" || stage?.formatName === "Group") {
    items.push(
      { label: "Encounters", value: stage?.leagueRules?.encounters },
      { label: "Criteria", value: stage?.leagueRules?.criteria === "total" ? "Total Points" : "Direct Matches" },
      { label: "Points for Win", value: stage?.leagueRules?.pointsForWin },
      { label: "Points for Loss", value: stage?.leagueRules?.pointsForLoss }
    );
  }

  if (isAmericanoFormat(stage?.formatName)) {
    items.push(
      { label: "Points per Match", value: stage?.americanoRules?.pointsPerMatch },
      { label: "Rounds", value: formatPlannedRounds(stage?.americanoRules?.roundsCount) },
      { label: "Unit Size", value: stage?.americanoRules?.unitSize }
    );
    if (stage?.formatName === "Roulette") {
      items.push({
        label: "Players per Side",
        value: playersPerSideFor(stage?.americanoRules?.unitsPerSide, stage?.americanoRules?.unitSize),
      });
    }
    // Mexicano and Roulette never pair by gender.
    if (stage?.formatName === "Americano") {
      items.push({ label: "Mixed Pairing", value: stage?.americanoRules?.mixedPairing ? "Yes" : "No" });
    }
  }

  return (
    <Dialog
      open={props.isOpen}
      onClose={() => props.onClose()}
      placement="side"
      size="sm"
      title={
        <>
          {stage?.categoryName} - <b>{stage?.formatName}</b>
        </>
      }
      subtitle={stage?.tournamentName}
    >
      <section className="stage-detail-dialog">
        <h3 className="stage-detail-dialog__title">Round Details</h3>
        <DescriptionList items={items} columns={2} />
      </section>
      {/* <div className="footer">
        <button className="edit-btn" onClick={() => setIsEdit(true)}>
          Edit stage details
        </button>
      </div> */}
    </Dialog>
  );
};

export default StageDetailDialog;
